import { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Info from '../../components/Info';
import DateFormat from '../../components/DateFormat';
import Price from '../../components/Price';
import Phone from '../../components/Phone';
import RepositoryModel from '../../components/RepositoryModel';
import Button, { BUTTON_POSITION, BUTTON_TYPE } from '../../components/Button';
import Alert from '../../components/Alert';
import Section from '../../components/Section';

const RefundInfo = ({refund, onClose = () => {}}) => {
  const {t} = useTranslation(['common', 'refund']);

  const [errors, setErrors] = useState([]);

  const handleCloseError = (uid) => {
    setErrors(errors.filter((e) => e.uid !== uid));
  };

  useEffect(() => {
  }, []);

  return (
    <div className="trip-app">
      <div className="trip-app-body">
        {(errors.length > 0) && errors.map((error, i) => (
          <Alert type={error.type} key={error.uid || i} title={error.title} dismissible={true} onClose={() => handleCloseError(error.uid)}>{error.message}</Alert>
        ))}

        <Section className="refund-order-section" title={t('refund:refund_info.order', {order: refund.order.number})} visible={false}>
          <Info title={t('refund:refund_info.excursion')}>
            {refund.order.excursion?.title}
          </Info>
          {refund.order.client && (
            <Info title={t('refund:refund_info.client')}>
              <div>{refund.order.client.fullName}</div>
              <div><Phone.Call value={refund.order.client.phone}/></div>
            </Info>
          )}
          {refund.order.passengers && (
            <Info title={t('refund:refund_info.passengers')}>
              {refund.order.passengers.map((passenger) => (
                <Fragment key={passenger.id}>
                  {passenger.price && (
                    <div>
                      {passenger.count} <RepositoryModel type="Price" uid={passenger.price.id} render={(model) => model.title} />
                    </div>
                  )}
                </Fragment>
              ))}
            </Info>
          )}
        </Section>

        <Info title={t('refund:refund_info.type')}>
          {t(`refund:refund_type.${refund.type}`)}
        </Info>
        <Info title={t('refund:refund_info.for')}>
          {t(`refund:refund_for.${refund.for}`)}
        </Info>
        {refund.initiator && (
          <Info title={t('refund:refund_info.initiator')}>
            <div>{refund.initiator.fullName}</div>
            <div><Phone.Call value={refund.initiator.phone}/></div>
          </Info>
        )}
        <Info title={t('refund:refund_info.save_salary')}>
          {t(`common:bool.${refund.saveSalary}`)}
        </Info>
        <Info title={t('refund:refund_info.method')}>
          {t(`common:payment_method.${refund.method}`)}
        </Info>
        <Info title={t('refund:refund_info.amount')}>
          <Price value={refund.amount} />
        </Info>
        {refund.user && refund.user.id && (
          <Info title={t('refund:refund_info.user')}>
            <div>{refund.user.fullName}</div>
            <div><Phone.Call value={refund.user.phone}/></div>
          </Info>
        )}
        <Info title={t('refund:refund_info.status')}>
          {t(`refund:refund_status.${refund.status}`)}
        </Info>
        <Info title={t('refund:refund_info.auto_approved')}>
          {t(`common:bool.${refund.autoApproved}`)}
        </Info>
        {refund.passengers && (
          <Info title={t('refund:refund_info.passengers')}>
            {refund.passengers.map((passenger) => (
              <div key={passenger.id}>
                <Price value={passenger.amount} />
              </div>
            ))}
          </Info>
        )}
        {false && refund.refundPolicy && (
          <Info title={t('refund:refund_info.refund_policy')}>
            {refund.refundPolicy}
          </Info>
        )}
        {false && refund.refundPolicyRule && (
          <Info title={t('refund:refund_info.refund_policy_rule')}>
            {refund.refundPolicyRule}
          </Info>
        )}
        {refund.reason && (
          <Info title={t('refund:refund_info.reason')}>
            {refund.reason}
          </Info>
        )}
        {refund.errorMessage && (
          <Info title={t('refund:refund_info.error_message')}>
            {refund.errorMessage}
          </Info>
        )}
        {refund.rejectReason && (
          <Info title={t('refund:refund_info.reject_reason')}>
            {refund.rejectReason}
          </Info>
        )}
        {refund.approvedAt && (
          <Info title={t('refund:refund_info.approved_at')}>
            <DateFormat date={refund.approvedAt} />
          </Info>
        )}
        {refund.lastTryAt && (
          <Info title={t('refund:refund_info.last_try_at')}>
            <DateFormat date={refund.lastTryAt} />
          </Info>
        )}
      </div>
      <div className="trip-app-footer">
        <Button.Panel>
          <Button position={BUTTON_POSITION.RIGHT} variant={BUTTON_TYPE.SECONDARY} onClick={onClose}>{t('common:button.close')}</Button>
        </Button.Panel>
      </div>
    </div>
  )
}

RefundInfo.propTypes = {
  refund: PropTypes.object.isRequired
};

export default RefundInfo;